import { INVESTMENT_STATUS, LOAN_STATUS } from "@/lib/finance";

const TONES = {
  activa: "bg-emerald-500/15 text-emerald-700 dark:text-emerald-400 border-emerald-500/30",
  vigente: "bg-emerald-500/15 text-emerald-700 dark:text-emerald-400 border-emerald-500/30",
  en_salida: "bg-amber-500/15 text-amber-700 dark:text-amber-400 border-amber-500/30",
  vencido: "bg-red-500/15 text-red-700 dark:text-red-400 border-red-500/30",
  cerrada: "bg-slate-500/15 text-slate-600 dark:text-slate-300 border-slate-500/30",
  liquidado: "bg-sky-500/15 text-sky-700 dark:text-sky-400 border-sky-500/30",
};

export const StatusBadge = ({ status, testid }) => {
  const label = INVESTMENT_STATUS[status] || LOAN_STATUS[status] || "Sin definir";
  const tone = TONES[status] || "bg-slate-500/10 c-muted border-slate-500/30 italic";
  return <span data-testid={testid} className={`text-[11px] font-semibold px-2 py-0.5 rounded-full border whitespace-nowrap ${tone}`}>{label}</span>;
};

export const CurrencyBadge = ({ currency }) => (
  <span className={`font-mono text-[10px] px-1.5 py-0.5 rounded border c-line ${currency ? "c-accent" : "c-muted italic"}`}>{currency || "Sin moneda"}</span>
);
